// extracted by mini-css-extract-plugin
module.exports = {"appWidth":"layout_appWidth__3fXug","docWidth":"layout_docWidth__2YXlC"};